module.exports = __webpack_public_path__ + "img/life-at-ommax-6.c09c426b.jpg";